<style lang="scss">
@import '~scss/_variables';

main.about {
    color: $color-text-1;
    text-align: left;

    &.show-enter,
    &.show-leave-to {
        opacity: 0;

        .body {
            transform: translate(0, 60vh);
        }
    }

    &.show-enter-active,
    &.show-leave-active {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;

        .body {
            transition: transform 0.6s $easing-easeOutCubic;
        }
    }

    &.show-enter {
        .logo-animated {
            transform-origin: 50% 0%;
            transform: translateY(30vh) perspective(2000px) rotate3d(1, 0, 0, -60deg) scale(0.8);
        }
    }

    &.show-enter-active {
        transition: opacity 0.6s ease;

        .logo-animated {
            transition: transform 0.6s $easing-easeOutCubic;
        }
    }

    &.show-leave-to {
        .logo-animated {
            transform-origin: 50% 0%;
            transform: translateY(-150%);
        }
    }

    &.show-leave-active {
        transition: opacity 0.3s ease-in;

        .logo-animated {
            transition: transform 0.2s $easing-easeInCubic;
        }
    }

    .logo-large {
        display: block;
        width: 100%;
        user-select: none;

        &.bottom {
            margin-top: $grid-size * 5;
        }
    }

    .subtitle {
        font-family: $font-family-2;
        font-size: 14px;
        font-weight: lighter;
        text-transform: uppercase;
        letter-spacing: 4px;
        color: $color-black;
    }

    .container {
        max-width: $grid-size * 26;
        margin-left: auto;
        margin-right: auto;

        .content {
            max-width: $grid-size * 18;
            margin: 47px auto;
            font-size: 28px;
            text-align: justify;

            p {
                margin-bottom: 0.8em;
            }
        }
    }

        .heading {
            user-select: none;

            span {
                display: block;
            }

            .large {
                font-family: $font-family-2;
                font-size: 64px;
                line-height: 0.85;
                color: $color-white;
            }
        }

    section.description {
        margin-top: 138px;
        margin-bottom: 138px;
    }

    section.featured {
        position: relative;
        max-width: ($grid-size * 36);
        margin: 0 auto;
        margin-bottom: ($grid-size * 3);
        padding: 0.1px 0;
        background-color: $color-text-1;

        @include media-larger('md') {
            &:after {
                content: '';
                width: 100%;
                height: 100%;
                position: absolute;
                top: $grid-size;
                left: $grid-size;
                z-index: -1;
                background: $color-white;
            }
        }

        .heading {
            margin-top: ($grid-size * 2);
        }

        .subtitle {
            color: $color-white;
        }

        .large {
            color: $color-accent-1;
        }

        .brands-container {
            margin: ($grid-size * 2) ($grid-size / 2);

            @include media-larger('md') {
                margin-left: ($grid-size * 3);
                margin-right: ($grid-size * 3);
            }
        }

        .brands {
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            margin: -25px -20px;

            @include media-larger('md') {
                justify-content: space-between;
            }

            a {
                padding: 25px 20px;
            }

            img {
                max-width: 240px;
                max-height: 60px;

                @include media-smaller('md') {
                    max-width: 140px;
                    max-height: 60px;
                }
            }
        }
    }

    section.founders {
        margin-bottom: 155px;

        .content {
            margin-top: 63px;
        }

            .brand {
                margin-bottom: 60px;
                text-align: left;
            }

                .logo {
                    margin-bottom: 8px;
                    max-height: $grid-size * 3;
                }

        @include media-larger('sm') {
            .brand {
                line-height: $grid-size;
            }
        }
    }

    section.contact {
        margin-bottom: 184px;

        h2 {
            position: relative;
            padding-top: $grid-size * 2;

            .fa-at {
                position: absolute;
                    top: 0;
                    left: $grid-size * 4;
                font-size: 72px;
            }
        }

        .download {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: $grid-size;

            font-family: $font-family-2;
            font-weight: $font-weight-2-bold;
            font-size: 36px;
            text-align: left;
            color: $color-black;

            .icon {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 1em;
                height: 1em;
                margin-right: 17px;
                border-radius: 10px;

                font-size: $grid-size;
                background: $color-black;

                svg {
                    font-size: 16px;
                    color: $color-accent-1;
                    transition: transform $transition-download-icon;
                }
            }

            &:hover {
                .icon svg {
                    transform: scale(1.25);
                }
            }
        } // button

        .contact {
            max-width: 22.5em;
            margin-bottom: 25px;

            font-size: 20px;
            line-height: 1.6;
            text-align: left;

            p {
                margin-bottom: 0;
            }

            a {
                font-size: 28px;
                font-weight: bold;
                text-decoration: underline;
                color: $color-white;
            }
        }

        @include media-smaller('md') {
            h2 {
                padding-top: $grid-size;

                .fa-at {
                    font-size: $grid-size;
                }
            }

            .download {
                font-size: 18px;
            }

            .contact {
                font-size: 18px;

                a {
                    font-size: 20px;
                }
            }
        }
    } // section.contact

    section.sources {
        .content {
            margin-top: 32px;
        }

            ul {
                padding: 0;
                font-size: 20px;
                list-style-type: none;

                hr {
                    margin: $grid-size 0;
                    border: none;
                    border-top: 2px solid $color-border-1;
                }
            }

                li {
                    display: block;
                    margin-bottom: 8px;
                    padding-left: 24px;
                    position: relative;
                    text-align: left;

                    &:before {
                        content: '—';
                        margin-right: 6px;
                        position: absolute;
                            top: 0;
                            left: 0;
                    }
                }

        @include media-smaller('md') {
            li {
                display: block;
                width: 100%;
                margin-bottom: 14px;
            }
        }
    } // section.sources

    @include media-smaller('lg') {
        .container {
            max-width: $grid-size * 18;
        }
    }

    @include media-smaller('md') {
        padding-top: $grid-size * 2;

        .container {
            max-width: none;
            padding: 0 $mobile-pad;

            .content {
                font-size: 18px;
            }
        }

            .heading {
                .large {
                    font-size: 42px;
                }
            }
    }
}
</style>

<template>
    <transition name="show">
        <main class="about">
            <img class="logo-large logo-animated" src="../assets/img/logo-large.svg" alt="Mission Emission" draggable="false">

            <div class="body">
                <section class="description container">
                    <h1 class="heading">
                        <span class="subtitle">About</span>
                        <span class="large">The Project</span>
                    </h1>

                    <div class="content">
                        <p>Every year traveling is becoming more and more affordable. Distance is no longer a barrier. However, there is another side of traveling.</p>
                        <p>Mission Emission is a project that aims to raise awareness of the environmental impact of traveling.</p>
                        <p>Heads of state and other leaders affirmed their commitments to fight climate change at the One Planet Summit in Paris on December 12, on the second anniversary of the Paris Agreement. Their calls for concrete action came as concentrations of the greenhouse gas carbon dioxide reached their highest level in 800,000 years. CO<sub>2</sub> emissions rose 60% between 1990 and 2014. In the last three years, global emissions had leveled off, but in 2017 they began to rise again.</p>
                        <p>We believe that actions need to be taken and it is up to every one of us to do something to help limit our carbon footprint.</p>
                        <p>This tool is our team’s contribution to the global community. We hope that you will find it useful and it will help you and your friends and family to be more aware of the environmental impact of traveling.</p>
                    </div>
                </section>

                <section class="featured">
                    <div class="container">
                        <h2 class="heading">
                            <span class="subtitle">Articles</span>
                            <span class="large">Featured</span>
                        </h2>
                    </div>

                    <div class="brands-container">
                        <div class="brands">
                            <a v-for="article in articles" :key="article.href" :href="article.href" target="_blank">
                                <img :src="article.image">
                            </a>
                        </div>
                    </div>
                </section>

                <section class="founders container">
                    <h2 class="heading">
                        <span class="subtitle">Who are we?</span>
                        <span class="large">About Us</span>
                    </h2>

                    <div class="content">
                        <div class="brand">
                            <a :href="presets('links').companies.oblik" target="_blank">
                                <img class="logo" src="../assets/img/brands/oblik.svg" alt="Oblik Studio logo">
                            </a>

                            <p><a :href="presets('links').companies.oblik" target="_blank"><strong>Oblik Studio</strong></a> is a product design company that is passionate about design in every aspect. We are focused on creating meaningful products and solutions that work for people.</p>
                        </div>
                        <div class="brand">
                            <a :href="presets('links').companies.betapeak" target="_blank">
                                <img class="logo" src="../assets/img/brands/betapeak.png" alt="BetaPeak logo">
                            </a>

                            <p><a :href="presets('links').companies.betapeak" target="_blank"><strong>BetaPeak</strong></a> is a software agency making the internet better with engineering services, innovative tools, and dependable methods. We take the pain out of building seed and early-stage products.</p>
                        </div>
                    </div>
                </section>

                <section class="contact container">
                    <h2 class="heading">
                        <span class="subtitle">Get in touch</span>
                        <span class="large">Contact Us</span>
                        <fa :icon="['fas', 'at']"></fa>
                    </h2>

                    <div class="content">
                        <a class="download" href="/press-kit.zip" download="mission-emission">
                            <span class="icon">
                                <fa :icon="['fas', 'file-download']"></fa>
                            </span>
                            <span>Download Press Kit</span>
                        </a>

                        <div class="contact">
                            <p>If you have any tips, feedback or collaboration ideas, don’t hestitate to get in touch at:</p>
                            <a href="mailto:hello@missionemission.co">hello@missionemission.co</a>
                        </div>

                        <div class="contact">
                            <p>In case you need a design or development partner for your next digital project, write us at:</p>
                            <a href="mailto:business@missionemission.co">business@missionemission.co</a>
                        </div>
                    </div>
                </section>

                <section class="sources container">
                    <h2 class="heading">
                        <span class="subtitle">We get the data from</span>
                        <span class="large">Sources</span>
                    </h2>

                    <div class="content">
                        <ul>
                            <li v-for="(source, index) in sources" :key="index">
                                <a v-if="source.length > 1" :href="source[1]" target="_blank">{{ source[0] }}</a>
                                <template v-else>{{ source[0] }}</template>
                            </li>

                            <hr>

                            <li><a href="/policies.html" target="_blank">Policies</a></li>
                        </ul>
                    </div>
                </section>
            </div>

            <router-link to="/" class="logo-link">
                <img class="logo-large bottom" src="../assets/img/logo-large-alt.svg" alt="Mission Emission" draggable="false">
            </router-link>
        </main>
    </transition>
</template>

<script>
export default {
    data () {
        return {
            articles: {
                producthunt: {
                    href: 'https://www.producthunt.com/posts/mission-emission',
                    image: require('../assets/img/brands/producthunt.svg')
                },
                bnt: {
                    href: 'https://www.bnt.bg/en/a/bulgarian-app-measures-harmful-emissions-of-each-car-journey',
                    image: require('../assets/img/brands/bnt.png')
                },
                inhabitat: {
                    href: 'https://inhabitat.com/this-calculator-tracks-the-carbon-emissions-of-your-travels/',
                    image: require('../assets/img/brands/inhabitat.png')
                },
                hackernews: {
                    href: 'https://news.ycombinator.com/item?id=18618809',
                    image: require('../assets/img/brands/hackernews.svg')
                },
                techly: {
                    href: 'https://www.techly.com.au/2018/12/31/driving-car-even-worse-planet-thought/',
                    image: require('../assets/img/brands/techly.svg')
                },
                ideasforgood: {
                    href: 'https://ideasforgood.jp/2019/01/29/mission-emission/',
                    image: require('../assets/img/brands/ideasforgood.png')
                },
                megacurioso: {
                    href: 'https://www.megacurioso.com.br/ciencia/110479-site-calcula-quanto-dioxido-de-carbono-o-seu-carro-emite-em-uma-viagem.htm',
                    image: require('../assets/img/brands/megacurioso.png')
                },
                engenhariae: {
                    href: 'http://engenhariae.com.br/meio-ambiente/site-calcula-as-emissoes-de-co2-que-voce-produzira-ao-viajar-para-destinos-especificos/',
                    image: require('../assets/img/brands/engenharia.png')
                },
                bloomberg: {
                    href: 'https://www.bloombergtv.bg/update/2019-02-02/misiya-emisiya-otchita-nivata-na-zamarsyavane-i-predlaga-alternativi-za-redutsiraneto-mu',
                    image: require('../assets/img/brands/bloomberg.svg')
                },
                btv: {
                    href: 'https://btvplus.bg/produkt/predavaniya/14443',
                    image: require('../assets/img/brands/btv.svg')
                },
                dnevnik: {
                    href: 'https://www.dnevnik.bg/skorost/2018/12/01/3352538_bulgarska_razrabotka_izchisliava_vrednite_emisii_pri/',
                    image: require('../assets/img/brands/dnevnik.svg')
                }
            },
            sources: [
                ['OICA', 'http://www.oica.net/category/sales-statistics/'],
                ['International Journal of science', 'https://www.nature.com'],
                ['United States Environmental Protection Agency', 'https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle'],
                ['ACEA', 'http://www.acea.be/statistics/article/Passenger-Car-Fleet-by-Fuel-Type'],
                ['U.S. Energy Information Administration', 'https://www.eia.gov/tools/faqs/faq.php?id=74&t=11'],
                ['U.S. Department of Transportation Federal Highway Administration', 'https://www.fhwa.dot.gov/ohim/onh00/bar8.htm'],
                ['The World Bank', 'http://databank.worldbank.org/data/reports.aspx?source=2&type=metadata&series=IS.AIR.PSGR#'],
                ['US Energy Information Administration', 'https://www.eia.gov/Energyexplained/?page=us_energy_transportation#tab2'],
                ['APTA', 'http://www.apta.com/resources/statistics/Pages/transitstats.aspx'],
                ['IEA', 'https://webstore.iea.org/co2-emissions-from-fuel-combustion-highlights-2017'],
                ['GIZ China | Energising-Transport and Mobil in China', 'https://www.giz.de/en/downloads/giz2016_en_MKS%20Status%20Analysis%20China.pdf'],
                ['EDGAR', 'http://edgar.jrc.ec.europa.eu/overview.php?v=CO2andGHG1970-2016&sort=des8'],
                ['Nature.com', 'https://www.nature.com'],
                ['Transport & Environment', 'https://www.transportenvironment.org/sites/te/files/2017_09_Diesel_report_final.pdf'],
                ['ACEA', 'https://www.acea.be/statistics/tag/category/average-vehicle-age'],
                ['Australian Government, Department of the Environment and Energy', 'http://www.environment.gov.au/protection/publications/factsheet-nitrogen-dioxide-no2'],

                ['Trends and projections in the EU ETS in 2017 The EU Emissions Trading System in numbers EEA Report No 18/2017 ISSN 1977-8449'],
                [`© EEA, Copenhagen, 2016 Reproduction is authorised, provided the source is acknowledged, save where otherwise stated. Luxembourg: Publications Office of the European Union, 2016 ISBN 978-92-9213-723-6 doi:10.2800/71804`]
            ]
        };
    }
};
</script>
